<template>
    <c-dialog ref="dialog" width="550" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="资产编号">
                <c-input name="asset_code" :placeholder="this.editState?'请输入资产编号':'不填，将自动生成'"></c-input>
            </c-form-item>

            <c-form-item label="资产名称" required>
                <c-input name="asset_name" maxlength="200"></c-input>
            </c-form-item>

            <c-form-item label="所属分类" required>
                <c-select name="asset_category" :options="assetCategoryDic"></c-select>
            </c-form-item>

            <c-form-item label="单位" required>
                <c-select name="unit" async @search="searchUnit" :value-data="selectedUnit" clearable></c-select>
            </c-form-item>

            <c-form-item label="所属网点" required>
                <c-select name="outlet_id" async @search="searchOutlet" :value-data="selectedOutlet" clearable></c-select>
            </c-form-item>

            <c-form-item label="使用年限">
                <c-input name="service_life_year" type="number" :precision="0" append-text="年">
                </c-input>
            </c-form-item>

            <c-form-item label="资产图片">
                <c-upload-file name="image_url" :limit="1" :file-list="imageFileList" type="image" button="上传图片" @change="imageChange" media></c-upload-file>
            </c-form-item>

            <c-form-item label="状态" required>
                <c-select name="status" :options="assetStatusDic"></c-select>
            </c-form-item>

            <c-form-item label="资产描述">
                <c-input name="asset_desc" maxlength="255" :rows="3"></c-input>
            </c-form-item>

            <c-form-item label="附加资产描述">
                <c-input name="sub_asset_desc" maxlength="255" :rows="3"></c-input>
            </c-form-item>

            <c-form-item label="开始使用日期">
                <c-datetime name="start_use_date" type="date" format="yyyy-MM-dd" placeholder="请选择日期"></c-datetime>
            </c-form-item>

            <c-form-item label="备注">
                <c-input name="remark" type="textarea" maxlength="1000" :rows="3"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
export default {
    computed: {
        ...mapState(['disableEnableDic', 'assetStatusDic', 'assetCategoryDic'])
    },
    data() {
        return {
            selectedCategory: [],
            selectedUnit: [],
            selectedOutlet: [],
            imageFileList: [],
            editState: false
        }
    },

    methods: {
        /*********打开编辑框，初始化**********/
        async open(data, actionType) {
            this.$refs.form.clear();
            this.selectedCategory = [];
            this.selectedUnit = [];
            this.selectedOutlet = [];
            this.imageFileList = [];
            this.editState = false;

            if (data) {
                //查询资产详情
                this.request({
                    url:'/fixed_asset/detail',
                    data: {
                        id:data.id
                    },
                    success:data => {
                        this.$refs.form.set(data);
                        //已选中的分类
                        if(data.asset_category){
                            this.selectedCategory = [{
                                name: data.asset_category,
                                value: data.asset_category
                            }];
                        }
                        //已选中的单位
                        if(data.unit){
                            this.selectedUnit = [{
                                name: data.unit_name,
                                value: data.unit
                            }];
                        }
                        //已选中的网点
                        if(data.outlet_id && data.outlet_name){
                            this.selectedOutlet = [{
                                name: data.outlet_name,
                                value: data.outlet_id
                            }];
                        }
                        //图片
                        if(data.image_url){
                            this.imageFileList = [{
                                name: '资产图片',
                                url: data.image_url
                            }];
                        }
                    }
                })
                this.editState = true;
            }

            let title = '新增资产档案';
            if (this.editState) {
                title = actionType === 'use' ? '资产占用' : '编辑资产档案';
            }

            //填充 form 表单
            this.$refs.dialog.open({
                title: title
            });
        },

        /*******搜索单位*****************/
        searchUnit(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'DICUNIT',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        /*******搜索网点*****************/
        searchOutlet(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'AFTERSALE_OUTLET',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        /*******图片处理********/
        imageChange(files) {
            if (files && files.length > 0) {
                this.$refs.form.set({image_url: files[0].url});
            } else {
                this.$refs.form.set({image_url: ''});
            }
        },

        /*******创建、编辑提交处理方法********/
        editHandle (stop, next){
            stop();
            this.$refs.form.submit({
                url: this.editState?'/fixed_asset/edit':'/fixed_asset/add',
                rule: {
                    asset_name: '请输入资产名称',
                    asset_category: '请选择所属分类',
                    unit: '请选择单位',
                    outlet_id: '请选择所属网点',
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    if (this.editState){//编辑
                        this.$message({
                            message: '编辑成功',
                            type: 'success'
                        });
                    }else {//新增
                        this.$message({
                            message: '新增成功',
                            type: 'success'
                        });
                    }
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
